<template>
  <div class="d-flex justify-space-between align-center pa-3">
    <v-btn
      v-if="userHasAdminRights"
      id="save-template-button"
      color="primary"
      @click="$emit('save-template')"
      >{{ $t("save") }}</v-btn
    >
    <h2 class="text-h6 notranslate">
      {{ templateFullName }}
    </h2>
    <v-btn
      id="plain-text-button"
      color="primary"
      outlined
      @click="showDialog('plainTextMail')"
      >{{ $t("textVersion") }}</v-btn
    >
    <v-btn
      id="close-editor-button"
      color="primary"
      outlined
      @click="clickCloseButton"
      >{{ closeButtonText }}</v-btn
    >
    <default-dialog
      v-if="selectedDialog"
      :show-dialog="selectedDialog.show"
      :width="selectedDialog.width"
      :title="$t(selectedDialog.titleKey)"
      :include-actions="selectedDialog.includeActions"
      @close-dialog="closeDialog"
    >
      <template #dialog-content>
        <component
          :is="selectedDialog.content"
          :ref="selectedDialog.ref"
          :template-full-name="templateFullName"
          :show-dialog="selectedDialog.show"
          :plain-text="plainText"
          :template="selectedTemplate"
          :user-has-admin-rights="userHasAdminRights"
          @close-dialog="closeDialog"
          @update:plain-text="$emit('update:plain-text', $event)"
        ></component>
      </template>
    </default-dialog>
  </div>
</template>

<script>
import dialogs from "@/mixins/dialogs";
import DefaultDialog from "@/components/dialogs/DefaultDialog";
import PlainTextMail from "@/components/dialogs/PlainTextMail";
import emailTemplateNames from "@/mixins/emailTemplateNames";

export default {
  name: "EmailEditorToolbar",
  components: { DefaultDialog, PlainTextMail },
  mixins: [dialogs, emailTemplateNames],
  props: {
    userHasAdminRights: {
      type: Boolean,
      required: true,
    },
    selectedTemplate: {
      required: false,
      type: Object,
      default: null,
    },
    plainText: {
      required: true,
      type: String,
    },
  },
  computed: {
    closeButtonText() {
      if (this.userHasAdminRights) {
        return this.$t("closeEditor");
      }
      return this.$t("closePreview");
    },
    templateFullName() {
      if (!this.selectedTemplate) {
        return "";
      }
      return (
        this.selectedTemplate.name +
        " (" +
        this.getTemplateTypeName(this.selectedTemplate.templateType) +
        ", " +
        this.getTemplateLocaleName(this.selectedTemplate.locale) +
        ")"
      );
    },
  },
  methods: {
    clickCloseButton() {
      if (this.userHasAdminRights) {
        this.$emit("close-editor");
      } else {
        this.$emit("close-preview");
      }
    },
  },
};
</script>
